import { EdgeName, SunSailType } from "@biz/definitions/SunSailDefinitions";
import { getEdgeName } from "@biz/definitions/SunSailDefinitions.util";
import { SunSailTopology } from "@biz/items/sunSail/logic/SunSailTopology";

export class SunSailEdges {
  static getEdgeNames(sunSailType: SunSailType, poleCount: number): EdgeName[] {
    const topology = SunSailTopology.calcTopology(sunSailType, poleCount);
    return topology.sides.filter((s) => s.netBorder).map((s) => getEdgeName(s.first, s.second));
  }

  static getEdgeNameForPole(sunSailType: SunSailType, poleCount: number, poleIndex: number): EdgeName {
    return SunSailEdges.getEdgeNames(sunSailType, poleCount)[poleIndex];
  }

  static hasEdgeData(sunSailType: SunSailType): boolean {
    return sunSailType === SunSailType.Fixed;
  }

}